export function romeCandidates(day, time) {
  if(!/^\d{4}-\d{2}-\d{2}$/.test(day||"")||!/^\d{2}:\d{2}$/.test(time||"")) return [];
  const local=`${day}T${time}`;
  const formatter=new Intl.DateTimeFormat('sv-SE',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
  return ['+02:00','+01:00'].map(offset=>local+offset).filter(value=>{
    const d=new Date(value);return !Number.isNaN(d.getTime())&&formatter.format(d).replace(' ','T')===local;
  });
}

export function romeInstant(day,time,offset) {
  const candidates=romeCandidates(day,time);
  if(!candidates.length) throw new Error('Orario non valido in Europe/Rome: verifica data e cambio dell’ora.');
  if(candidates.length===1) return candidates[0];
  const selected=candidates.find(c=>c.endsWith(offset||'nessuno'));
  if(!selected) throw new Error('Orario ripetuto nel cambio dell’ora: scegli la prima o la seconda occorrenza.');
  return selected;
}

export function timedPayload(form) {
  const {start_time,end_time,start_fold,end_fold,...payload}=form;
  // Explicit inputs override a previously selected search result.
  delete payload.start_at;delete payload.end_at;
  if(start_time||end_time){
    if(!start_time||!end_time) throw new Error('Indica entrambi gli orari oppure lascia entrambi vuoti per giornate intere.');
    payload.start_at=romeInstant(form.start_date,start_time,start_fold);
    payload.end_at=romeInstant(form.end_date_planned,end_time,end_fold);
    if(new Date(payload.end_at)<=new Date(payload.start_at)) throw new Error('Il rientro deve essere successivo al ritiro.');
  }
  return payload;
}

export function periodSelection(selection) {
  return {...selection,start_time:selection.start_at?.slice(11,16)||'',end_time:selection.end_at?.slice(11,16)||'',start_fold:selection.start_at?.slice(-6)||'',end_fold:selection.end_at?.slice(-6)||''};
}

export function displayInstant(value) {
  return value?new Intl.DateTimeFormat('it-IT',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',timeZoneName:'shortOffset'}).format(new Date(value)):'—';
}
